import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
// ----------------------------------------------------------------------
export const Select = () => {
    return {
        MuiSelect: {
            defaultProps: {
                IconComponent: ExpandMoreRoundedIcon
            },
            styleOverrides: {
                root: {}
            }
        }
    };
};
//# sourceMappingURL=Select.js.map